import { render } from "./IdleMiner.vue?vue&type=template&id=540fb0a0"
import script from "./IdleMiner.vue?vue&type=script&lang=js"
export * from "./IdleMiner.vue?vue&type=script&lang=js"

import "./IdleMiner.vue?vue&type=style&index=0&id=540fb0a0&lang=css"

import exportComponent from "/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/components/IdleMiner.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "540fb0a0"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('540fb0a0', __exports__)) {
    api.reload('540fb0a0', __exports__)
  }
  
  module.hot.accept("./IdleMiner.vue?vue&type=template&id=540fb0a0", () => {
    api.rerender('540fb0a0', render)
  })

}


export default __exports__